import lodashIsEqual from 'lodash/isEqual'

/** @internal */
export const isEqual = lodashIsEqual
